<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 mt-4 mb-5 pb-2">
                <div class="cctvcouncelling__sec">
                    <div class="councellist__flex">
                        <div class="counceltitle__flex">
                            <div>
                                <h5 class="councel__name">Asset Transfer Request Form</h5>
                            </div>
                        </div>

                        <div>
                            <h5 class="fusion_details">Fusion Details</h5>
                        </div>
                        <div class="building_Flex">
                            <div class="building_grid">
                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Building Code</label>
                                        <h6 class="building_from_text">36598745</h6>
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Building Name</label>
                                        <h6 class="building_from_text">Saraswathi Soudham, Ameerpet</h6>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Branch Code</label>
                                        <h6 class="building_from_text">215479544</h6>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Branch Name</label>
                                        <h6 class="building_from_text">Saraswathi Soudham, Ameerpet</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div>
                            <h5 class="fusion_details">Authorised Person</h5>
                        </div>

                        <div class="building_Flex">
                            <div class="building_grid">
                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">AGM Name</label>
                                        <h6 class="building_from_text">Kancharlapalli Siva Rama Krishna</h6>
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Dean Name</label>
                                        <h6 class="building_from_text">Kancharlapalli Siva Rama Krishna </h6>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Principal Name</label>
                                        <h6 class="building_from_text">Kancharlapalli Siva Rama Krishna</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h5 class="fusion_details">Assets Details</h5>
                        </div>

                        <div class="building_Flex">
                            <div class="building_grid">
                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Assets Code</label>
                                        <h6 class="building_from_text">60050003</h6>
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Major Category</label>
                                        <h6 class="building_from_text">Lease Hold Improvements</h6>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Minor Category</label>
                                        <h6 class="building_from_text">Art & Paintings - Capex</h6>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group">
                                        <label for="" class="build_label">Asset Type</label>
                                        <h6 class="building_from_text">Kancharlapalli Siva Rama Krishna</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <h5 class="fusion_details">Enter Following Details</h5>
                        </div>

                        <ul class="asset_description">Asset Description
                            <li class="asset_text">
                                <textarea class="form-control" aria-label="With textarea"></textarea>
                            </li>
                        </ul>
                        <ul class="asset_description">Reason for Transfer
                            <li class="asset_text">
                                <textarea class="form-control" aria-label="With textarea"></textarea>
                            </li>
                        </ul>
                        <ul class="asset_description">Transport Cost details
                            <li class="asset_text">
                                <textarea class="form-control" aria-label="With textarea"></textarea>
                            </li>
                        </ul>
                        <div class="text-center">
                            <button class="Submit" routerLink="/assetTransferList">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>